export default __webpack_public_path__ + "static/media/contentDesignLogo.45922a73.svg";